import { TCoordinate } from '../../../packages/api-models/common/json_query';

export const coordsArrayNumberToString = (coords: YMaps.TCoord[]): TCoordinate[] =>
  coords.map(coord => [String(coord[0]), String(coord[1])] as TCoordinate);
